import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d157420&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3d157420&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=3d157420&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d157420",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d157420')) {
      api.createRecord('3d157420', component.options)
    } else {
      api.reload('3d157420', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3d157420&scoped=true", function () {
      api.rerender('3d157420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkSignaturePad/index.vue"
export default component.exports